import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHeaderSection } from "../../../components/common/PageHeadSection";
import { Skeleton } from "antd";
import { HotelSelect } from "../../../components/common/HotelSelect";
import { useMutation, useQuery } from "react-query";
import { mdlAgencyMarketListRequest } from "../../../models/service-models/agency-market/AgencyMarketListRequest";
import { AgencyMarketService } from "../../../services/AgencyMarketService";
import { mdlAgencyMarketObj } from "../../../models/domain/value-objects/AgencyMarketObj";
import _ from 'lodash';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { mdlOtherAgency } from "../../../models/domain/OtherAgency";
import { mdlAgencyMarketUpdateRequest } from "../../../models/service-models/agency-market/AgencyMarketUpdateRequest";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../../utils/ObjectHelper";
import { MarketService } from "../../../services/MarketService";
import { mdlMarket } from "../../../models/domain/Market";
import { mdlAgencyMarket } from "../../../models/domain/AgencyMarket";
import { mdlAgencyMarketMap } from "../../../models/domain/AgencyMarketMap";

export const AgencyMarketDefinition = () => {
    const { t } = useTranslation();
    const [selectedHotel, setSelectedHotel] = useState<string>();
    const [request, setRequest] = useState<mdlAgencyMarketListRequest>();
    const [agencyMarketList, setAgencyMarketList] = useState<mdlAgencyMarket[]>();
    useEffect(() => {
        if (selectedHotel)
            refetch();refetchMarket();
    }, [selectedHotel]);


    const {
        data: dataMarket,
        isLoading: isLoadingMarket,
        refetch: refetchMarket,
    } = useQuery(
        ["getMarkets", selectedHotel, request],
        () => {
            if (selectedHotel)
                return MarketService.List({ ...request, hotelId: selectedHotel, pageSize:0 });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel
        }
    );
    
    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getAgencyMarkets", selectedHotel],
        () => {
            if (selectedHotel)
                return AgencyMarketService.List({ hotelId: selectedHotel });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel,
            onSuccess(data) {
                if(data && data.body && data.body.data){
                    setAgencyMarketList(data.body.data);
                }
            },
        }
    );

    const handleHotelSelect = (hotelId: string) => {
        setAgencyMarketList(undefined);
        setSelectedHotel(hotelId);
    }

    let markets = dataMarket?.body?.data;

    const getMarketHeaders = () => {
        return (
            markets?.map((market: mdlMarket, index: number) => (
                <th key={index} scope="col"> {market.name} </th>
            ))
        )
    }


    const handleChange = (agency?: mdlOtherAgency, marketId?: string) => {
        const _updateRequest = { agencyId: agency?.id, marketId: marketId, hotelId: selectedHotel, agencyType: agency?.agencyType } as mdlAgencyMarketUpdateRequest;
        saveAgencyMarket.mutate(_updateRequest, {
        onError: error => {
            console.log(error);
        },
        onSuccess(data){
            if (data.header?.success && data.body?.isSuccessful) {
                toast.success(t("common.success"));
                if(_updateRequest){
                    const _agencyMarketList = _.cloneDeep(agencyMarketList)?.map(x=> {
                        if(x.agency?.id == _updateRequest.agencyId){
                            if(x.marketMaps && x.marketMaps.find( y => y.marketId == _updateRequest.marketId)){
                                x.marketMaps = x.marketMaps?.filter( y=> y.marketId != _updateRequest.marketId)
                            }else{
                                x.marketMaps?.push({
                                        id: "",
                                        agencyId: _updateRequest.agencyId,
                                        marketId: _updateRequest.marketId,
                                        agencyType: _updateRequest.agencyType,
                                } as mdlAgencyMarketMap)
                            }
                        }
                        return x;
                    });
                    if(_agencyMarketList)
                        setAgencyMarketList(_agencyMarketList as mdlAgencyMarket[]);
                }
            }
        }
      })
    }


    const saveAgencyMarket = useMutation({
        mutationFn: (data:mdlAgencyMarketUpdateRequest) => {
          return AgencyMarketService.Update(data)
        },
      })
    

    const getMarket = (marketMaps: Array<mdlAgencyMarketMap>,market:mdlMarket) => {
        var result =  marketMaps?.find((x:mdlAgencyMarketMap)=> x.marketId == market.id);
        return result;
    }
    return (
        <>
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("definitions.agencyMarkets.title")}
                            />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                {
                                                    <HotelSelect onChange={handleHotelSelect} />
                                                }
                                                {
                                                    isLoading
                                                    &&
                                                    <>
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                    </>
                                                }
                                                {
                                                    agencyMarketList
                                                    &&
                                                    <div className="market-agency-map-area table-fixed-head table-wrapper ">
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">{t("definitions.agencyMarkets.agencyMarket")}</th>
                                                                    {
                                                                        getMarketHeaders()
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    agencyMarketList?.map((agencyMarket: mdlAgencyMarket, index: number) => (
                                                                        <tr key={index}>
                                                                            <th scope="col"> {agencyMarket?.agency?.name} </th>
                                                                            <>
                                                                                {
                                                                                    markets?.map((market: mdlMarket, marketIndex: number) => (
                                                                                        
                                                                                        <td onClick={() => handleChange(agencyMarket?.agency, market?.id)} style={{ cursor: "pointer" }} key={marketIndex}>{getMarket(agencyMarket.marketMaps ?? [], market) ? <CheckOutlined className="green-icon" /> : <CloseOutlined className="red-icon" />}</td>
                                                                                    ))
                                                                                }

                                                                            </>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
